import { Routes } from '@angular/router';
import { DefaultBodyComponent } from './layout/default-body/default-body.component';
import { LoginComponent } from './pages/login/login.component';
import { SelectCenterComponent } from './pages/select-center/select-center.component';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'select-center',
    component: SelectCenterComponent,
    canActivate: [authGuard],
  },
  {
    path: '',
    component: DefaultBodyComponent,
    canActivate: [authGuard],
    data: { title: 'Dashboard' },
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];
